import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import { listCategories } from '../actions/productActions';
import './CategoryNav.css';
import Loader from './Loader';
import Message from './Message';

function CategoryNav() {
    const dispatch = useDispatch();
    const categoryList = useSelector(state => state.categoryList);
    const { loading, error, categories } = categoryList;

    useEffect(() => {
        dispatch(listCategories());
    }, [dispatch]);

    return (
        <div className="category-nav">
            <h5>Categories</h5>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant="danger">{error}</Message>
            ) : (
                <ListGroup variant="flush">
                    {categories.map(category => (
                        <ListGroup.Item key={category._id}>
                            <Link to={`/category/${category.name}`}>{category.name}</Link>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </div>
    );
}

export default CategoryNav;
